import { map } from 'lodash/fp';

import { TaxRateStrategyCoProduct } from '@mews-distributor/common';
import { Stack, Typography } from '@optimus-web/core';

import { TaxRate } from '../TaxRate';

export interface LocalizedTaxValue {
    localName: string;
    value: string;
    strategy: TaxRateStrategyCoProduct;
}

export const mapTaxValues = map<LocalizedTaxValue, React.ReactElement>(({ localName, value, strategy }) => (
    <Stack spacing="200" distribution="space-between" key={`${localName}-${value}`}>
        <Typography textStyle="bodyMediumStrong" variant="secondary" data-test-id="tax-rate" as="div">
            <TaxRate name={localName} strategy={strategy} />
        </Typography>
        <Typography textStyle="bodyMediumStrong" variant="secondary" as="div">
            {value}
        </Typography>
    </Stack>
));
